import Vue from 'vue'
import he from 'he'

export default function () {
  return {
    isValidURL (url) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator

      return !!pattern.test(url)
    },
    camelize (text, separator = ' ', joinValue = ' ') {
      return text.split(separator).map(w => w.replace(/./, m => m.toUpperCase())).join(joinValue)
    },
    displayRemainingTickets (ticket, event) {
      return event.show_remaining_tickets && ticket.on_sale <= event.show_remaining_tickets_since
    },
    groupBy (array, key) {
      // Return the end result
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        )
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result
      }, {}) // empty object is the initial value for result object
    },
    getEventDate (event) {
      if (event.event_dates_attributes.length > 0) {
        var eventWeekDayStartsAt = event.event_dates_attributes[0].formatted_weekday_starts_at
        var eventMonthStartsAt = event.event_dates_attributes[0].formatted_month_starts_at
        var eventDayStartsAt = event.event_dates_attributes[0].formatted_day_starts_at
        var eventHourStartsAt = event.event_dates_attributes[0].formatted_time_starts_at

        return '<strong>' + eventWeekDayStartsAt + '</strong> ' +
          eventMonthStartsAt + ' ' + eventDayStartsAt + ' at ' + eventHourStartsAt
      }

      return ''
    },
    getEventFullDateTime (event) {
      if (event.event_dates_attributes.length > 1) {
        return 'Multiple dates'
      } else {
        return event.event_dates_attributes[0].formatted_full_date_time
      }
    },
    getEventStreetAddress (event) {
      let address = event.address_1

      if (event.address_2 && event.address_2.length > 0) {
        address = address.concat(', ' + event.address_2)
      }

      return address
    },
    getEventLocation (event) {
      let location = event.city

      if (event.state && event.state.length > 0) {
        location = location.concat(`, ${event.state}`)
      }

      if (event.zip_code && event.zip_code.length > 0) {
        location = location.concat(` ${event.zip_code}`)
      }

      return location
    },
    getEventFullAddress (event) {
      let fullAddress = `<b>${event.venue_name}</b>`

      if (event.address_1 && event.address_1.length > 0) {
        fullAddress = fullAddress.concat(`, ${event.address_1}`)
      }

      if (event.address_2 && event.address_2.length > 0) {
        fullAddress = fullAddress.concat(`, ${event.address_2}`)
      }

      if (event.city && event.city.length > 0) {
        fullAddress = fullAddress.concat(`, ${event.city}`)
      }

      if (event.state && event.state.length > 0) {
        fullAddress = fullAddress.concat(`, ${event.state}`)
      }

      if (event.zip_code && event.zip_code.length > 0) {
        fullAddress = fullAddress.concat(` ${event.zip_code}`)
      }

      return fullAddress
    },
    getDateRangeRelatedEvent (event, relatedEvent) {
      var relatedEventDate = relatedEvent.formatted_date_starts_at
      var eventDate = event.event_dates_attributes[0].formatted_date_starts_at

      if (relatedEventDate === eventDate) {
        return 'Starts at ' + relatedEvent.formatted_time_starts_at +
          ' to ' + relatedEvent.formatted_time_ends_at
      } else {
        return 'Starts at ' + relatedEvent.formatted_starts_at +
          ' to ' + relatedEvent.formatted_ends_at
      }
    },
    showRemainingTickets (event) {
      return event.show_remaining_tickets &&
        event.show_remaining_tickets_since &&
        (event.show_remaining_tickets_since >= event.remaining_tickets)
    },
    checkEventAvailability (event) {
      if (event && event.id && !event.event_available) {
        let eventTitle = this.encodeEventTitle(event.title)

        this.$router.push({
          name: 'customEventShow',
          params: {
            id: event.id,
            event_title: eventTitle
          }
        })
      }
    },
    purchaseStatus (purchase) {
      var statusStyle = null
      var statusText = purchase.status.replace('_', ' ')

      if (statusText === 'processed') {
        statusStyle = 'success'
      } else if (statusText === 'failed') {
        statusStyle = 'danger'
      } else if (statusText === 'in_process') {
        statusStyle = 'info'
      } else if (statusText === 'request_refund') {
        statusStyle = 'secondary'
      } else if (statusText === 'refunded') {
        statusStyle = 'primary'
      } else if (statusText === 'failed_refund') {
        statusStyle = 'warning'
      }

      return `<span class="badge badge-${statusStyle}">${statusText}</span>`
    },
    socialMediaLinks (socialMediaId, socialMediaType) {
      if (socialMediaType === 'facebook') {
        return `https://www.facebook.com/${socialMediaId}`
      } else if (socialMediaType === 'instagram') {
        return `https://www.instagram.com/${socialMediaId}`
      } else if (socialMediaType === 'twitter') {
        return `https://twitter.com/${socialMediaId}`
      } else {
        return null
      }
    },
    markedText (text) {
      if (text) {
        return Vue.prototype.$marked(text)
      } else {
        return ''
      }
    },
    extracNumbers (text) {
      return text.replace(/[^0-9]/g, '')
    },
    calculateBonusPrice (price, bonusPercentage) {
      return ((bonusPercentage * price) / 100) / 100
    },
    convertToCSV (objArray) {
      var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      var str = ''

      for (var i = 0; i < array.length; i++) {
        var line = ''
        for (var index in array[i]) {
          if (line !== '') line += ','

          line += array[i][index]
        }
        str += line + '\r\n'
      }

      return str
    },
    exportPurchasesLink (purchasesList, headers, fileName) {
      var purchases = JSON.stringify(purchasesList)

      var csvHeaders = this.convertToCSV(headers)
      var csvPurchases = this.convertToCSV(purchases)

      var blob = new Blob([csvHeaders + csvPurchases], { type: 'text/csv;charset=utf-8;' })

      const e = document.createEvent('MouseEvents')
      var link = document.createElement('a')
      link.download = fileName
      link.href = window.URL.createObjectURL(blob)
      link.dataset.downloadurl = ['text/csv;charset=utf-8;', link.download, link.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      link.dispatchEvent(e)
    },
    encodeEventTitle (eventTitle) {
      if (eventTitle && eventTitle.length > 0) {
        return he.encode(eventTitle.replace(/[|&;:$%@"<>()+,]/g, '').replace(/\s+/g, '-'))
      }

      return ''
    },
    includeStripe () {
      let self = this
      let documentTag = document
      let tag = 'script'
      let object = documentTag.createElement(tag)
      let scriptTag = documentTag.getElementsByTagName(tag)[0]

      object.src = 'https://js.stripe.com/v3/'
      object.addEventListener('load', function (e) { self.configureStripe(e) }, false)
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    remainingTickets (ticketsQty) {
      return `${ticketsQty} ${ticketsQty > 1 ? 'tickets' : 'ticket'} left`
    },
    profileTwitterAccount (siteConfiguration) {
      return siteConfiguration.organizer_profile && siteConfiguration.organizer_profile.twitter_id
    },
    profileSocialImageUrl (siteConfiguration) {
      return siteConfiguration.organizer_profile && siteConfiguration.organizer_profile.social_image_url
    },
    dynamicMetaTags (title, description, url, socialImageUrl, twitter) {
      let tags = [
        { property: 'og:title', content: title.substring(0, 59), id: 'og-title' },
        { property: 'og:description', content: description.substring(0, 159), id: 'og-description' },
        { property: 'og:type', content: 'website', id: 'og-type' },
        { property: 'og:url', content: url, id: 'og-url' }
      ]

      if (socialImageUrl) {
        tags.push({ property: 'og:image', content: socialImageUrl, id: 'og-image' })
      }

      if (twitter) {
        var twitterAccount = `@${twitter}`
        tags.push({ property: 'twitter:card', content: 'summary', id: 'twitter-card' })
        tags.push({ property: 'twitter:site', content: twitterAccount, id: 'twitter-site' })
        tags.push({ property: 'twitter:creator', content: twitterAccount, id: 'twitter-title' })
      }

      return tags
    }
  }
}
